// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"48d04b29","239":"9f49536c","455":"0646c0af"}[chunkId] + ".chunk.js";
};